import styled from '@emotion/styled';
import { layout, space } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

export const Label = styled('label', {
    shouldForwardProp,
})(layout, space);
